<app-modal
  [title]="'Detalles del contacto'"
  [loading]="loading"
  [showEditButton]="permissionAuth.canEdit('prospectos')"
  [editable]="editable"
  (onEditClick)="editableSwitcher()"
>
      <div class="mb-4 grid grid-cols-1 gap-3 md:grid-cols-3">
        <div class="rounded-lg bg-gray-50 p-3 text-sm text-gray-700 dark:bg-gray-800 dark:text-gray-300">
          <span class="text-gray-500 dark:text-gray-400">Creado por:</span>
          <span class="ml-1 font-medium">{{ userName || '-' }}</span>
        </div>
        <div class="rounded-lg bg-gray-50 p-3 text-sm text-gray-700 dark:bg-gray-800 dark:text-gray-300">
          <span class="text-gray-500 dark:text-gray-400">Última modificación por:</span>
          <span class="ml-1 font-medium">{{ userModName || '-' }}</span>
        </div>
        <div class="rounded-lg bg-gray-50 p-3 text-sm text-gray-700 dark:bg-gray-800 dark:text-gray-300">
          <span class="text-gray-500 dark:text-gray-400">Fecha última modificación:</span>
          <span class="ml-1 font-medium">
            @if (updatedAt) {
              {{ updatedAt | date: 'dd/MM/yyyy HH:mm' }}
            } @else {
              -
            }
          </span>
        </div>
      </div>

      <app-form [formGroup]="editForm">
        <div class="grid grid-cols-1 gap-3 md:grid-cols-2 mb-5">
          <div>
            <app-label for="param_canal_contacto_id">
              Canal de contacto
            </app-label>
            <app-select id="param_canal_contacto_id" formControlName="param_canal_contacto_id" placeholder="Seleccione un canal" [options]="canalesContactosOptions" />
          </div>

          <div>
            <app-label for="param_motivo_contacto_id">
              Motivo de contacto
            </app-label>
            <app-select id="param_motivo_contacto_id" formControlName="param_motivo_contacto_id" placeholder="Seleccione un motivo" [options]="motivosContactoOptions" />
          </div>

          <div>
            <app-label for="crm_campanha_id">
              Campaña
            </app-label>
            <app-select id="crm_campanha_id" formControlName="crm_campanha_id" placeholder="Seleccione una campaña" [options]="campanhasOptions" />
          </div>

          <div>
            <app-label for="param_estado_contacto_id">
              Estado
            </app-label>
            <app-select id="param_estado_contacto_id" formControlName="param_estado_contacto_id" placeholder="Seleccione un estado" [options]="estadosContactosOptions" />
          </div>

          <div>
            <app-label for="fecha">
              Fecha
            </app-label>
            <app-input-field id="fecha" name="fecha" type="datetime-local" formControlName="fecha" [className]="'dark:scheme-dark'" />
          </div>
        </div>

        <div>
          <app-label for="resultado">
            Resultado
          </app-label>
          <app-textarea id="resultado" formControlName="resultado" [rows]="4" />
        </div>
      </app-form>

      <app-edition-buttons *hasPermission="'prospectos:edit'"
        [editable]="editable"
        [valid]="editForm.valid"
        [process]="updating"
        [hideEditButton]="true"
        (onCancelClick)="refreshContacto()"
        (onGoBackClick)="close()"
        (onUpdateClick)="update()"
      />
</app-modal>
